// @ts-nocheck
import React from "react";
import clsx from "clsx";
import { TextProps } from "../text";

const weights: Record<Required<TextProps>["weight"], string> = {
  "100": "font-thin",
  "200": "font-extralight",
  "300": "font-light",
  "400": "font-normal",
  "500": "font-medium",
  "600": "font-semibold",
  "700": "font-bold",
  inherit: "font-inherit",
};
type ButtonVariant = "default" | "icon" | "chatSend";

const baseClasses =
  "text-sm flex  transition ease-in duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1";

const variants: Record<ButtonVariant, string> = {
  default: clsx(
    "font-medium",
    "hover:ring-button-border hover:ring-2 hover:shadow-button-shadow",
    "focus:ring-button-border rounded-md",
  ),
  icon: "p-2 rounded hover:bg-gray-200 focus:ring-gray-300",
  chatSend: clsx(
    "shadow-md",
    "hover:bg-chat-send-hover",
    "active:scale-95 transition-colors duration-200",
  ),
};

interface ButtonComponentProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isCenter?: boolean;
  weight?: "100" | "200" | "300" | "400" | "500" | "600" | "700" | "inherit";
  variant?: ButtonVariant;
}
export const ButtonComponent = (props: ButtonComponentProps) => {
  const {
    children,
    className,
    isCenter = true,
    disabled,
    type = "button",
    weight = "400",
    variant = "default",
    ...arg
  } = props;

  return (
    <button
      type={type}
      {...arg}
      disabled={disabled}
      className={clsx(
        baseClasses,
        variants[variant],
        variant === "default" && weights[weight],
        isCenter && "items-center justify-center",
        disabled &&
          "bg-dark-text text-white disabled:opacity-20 disabled:pointer-events-none",
        className ? className : "text-white",
      )}
    >
      {children}
    </button>
  );
};
